import { inject } from '@angular/core';
import { Auth, authState } from '@angular/fire/auth';
import { CanMatchFn, Router } from '@angular/router';
import { from, mergeMap } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { isAllowedSignInEmail } from './allowed-sign-in-email';
import { AuthService } from './auth.service';

export const authGuard: CanMatchFn = () => {
  const router = inject(Router);
  const authSvc = inject(AuthService);
  const auth = inject(Auth);

  return from(authSvc.redirectReadyPromise()).pipe(
    mergeMap(() =>
      authState(auth).pipe(
        take(1),
        map((user) => {
          if (!user) {
            return router.parseUrl('/login');
          }
          if (!isAllowedSignInEmail(user.email)) {
            return router.parseUrl('/unauthorized');
          }
          return true;
        }),
      ),
    ),
  );
};
